import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY } from "../config/COMPANY-INFO";

const SITE_URL = "https://apexdetailing.cz";

/**
 * Schema.org LocalBusiness (AutoDetailing sub-type does not exist in the
 * official vocabulary, so AutomotiveBusiness is the closest accurate match)
 * structured data — helps Google connect this site with the Apex Detailing
 * Google Business Profile / local pack results for queries like
 * "apex detailing prague" / "detailing praha".
 */
export default function LocalBusinessSchema() {
  const json = {
    "@context": "https://schema.org",
    "@type": "AutomotiveBusiness",
    name: COMPANY.tradeName,
    image: `${SITE_URL}/images/og-cover.jpg`,
    url: SITE_URL,
    telephone: COMPANY.contact.phoneRaw,
    email: COMPANY.contact.email,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: COMPANY.address.street,
      addressLocality: COMPANY.address.city,
      postalCode: COMPANY.address.zip,
      addressCountry: "CZ",
    },
    areaServed: ["Praha", "Zeleneč", "Praha-východ"],
    sameAs: [],
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(json)}</script>
    </Helmet>
  );
}
